import {useCallback, useEffect} from "react";
import {batch, useSignal} from "@preact/signals-react";
import {useAppToast} from "@ui-seeker/app"
import {postSubmit} from "@ui-seeker/utils";

import {BACKEND_APIS} from "@constants";
import {useUserApp} from "@hooks";
import {isLoadMoreItems, matcherSKUsItems} from "../@signals";
import useMatchersSKUsItems from "./useItems";


export default function useMatchersSKUsTarget() {
	const { username } = useUserApp()
	const { handleSubmit, handleMoreProducts } = useMatchersSKUsItems()
	const { showToast } = useAppToast()

	const selected = useSignal(null)
	const isQA = useSignal(false)
	const isLoadingMapping = useSignal(false)
	const targetIndex = useSignal(0)
	const targetData = matcherSKUsItems.value[targetIndex.value] || {}

	useEffect(() => {
		setSelectedSKU(targetData.skuSelected || null, false)
		if ((targetIndex.value + 1) === matcherSKUsItems.value.length)
			handleSubmit()
	}, [targetIndex.value])

	const __showToast = () => showToast.error(
		`SID: ${targetData.siteID} PID: ${targetData.productID} Failed!`, {
			position: "top-left"
		})

	const __saveExternalMapping = (notFound, skuID, brandID, skuName) => {
		postSubmit(`${BACKEND_APIS.MATCHERS}/skus/update-mapping`, {
			brandID,
			skuID,
			skuName,
			productID: targetData.productID,
			siteID: targetData.siteID,
			retailer: targetData.retailer,
			skip: notFound,
			validated: true,
			qa: true,
			username
		}).catch(() => {
			console.log('ERROR EXTERNAL MAPPING SKU')
			__showToast()
		})
	}

	const setSelectedSKU = useCallback((newValue, saveByQa=true) => {
		selected.value = newValue
		isQA.value = saveByQa
	}, [])

	const setTargetIndex = useCallback(newValue => {
		targetIndex.value = newValue
		batch(() => isLoadingMapping.value = false)
	}, [JSON.stringify(targetData)])

	const saveMapping = useCallback((notFound=false) => {
		isLoadingMapping.value = true
		let brandID = targetData.brandID
		let skuName = targetData.sku
		if (selected.value && !notFound) {
			const dataSelected = targetData.AIOptions.filter(item => item.skuID === selected.value)[0]
			if (dataSelected) {
				brandID = dataSelected.brandID || 0
				skuName = dataSelected.sku || ''
			}
		}

		const skuID = !notFound ? selected.value : 0
		setTargetIndex(targetIndex.value + 1)
		postSubmit(`${BACKEND_APIS.MATCHERS}/skus/mapping-product`, {
			productID: targetData.productID,
			siteID: targetData.siteID,
			skuID,
			brandID,
			productURL: targetData.productURL,
			notFound: notFound,
			qa: true
		}).then(() => __saveExternalMapping(notFound, skuID, brandID, skuName)).catch(e => {
			console.error('ERROR MAPPING SKU', e)
			__showToast()
		})
	}, [JSON.stringify(targetData), selected.value])

	const callNeedSku = useCallback(() => {
		setTargetIndex(targetIndex.value + 1)
		postSubmit(`${BACKEND_APIS.MATCHERS}/notifications/need-sku`, {...targetData})
			.catch(e => console.error('ERROR SEND NOTIFICATION', e))

		postSubmit(`${BACKEND_APIS.MATCHERS}/skus/mapping-product`, {
			productID: targetData.productID,
			siteID: targetData.siteID,
			skuID: 0,
			brandID: targetData.brandID,
			productURL: targetData.productURL,
			notFound: true,
			qa: true
		}).catch(e => console.error('ERROR SAVING SKU CANDIDATE', e))
	}, [targetIndex.value])

	return {
		targetIndex: targetIndex.value,
		targetData: targetData,
		selectedSKU: selected.value,
		isLoadingMapping: isLoadingMapping.value,

		finishItems: !isLoadMoreItems.value && targetIndex.value >= matcherSKUsItems.value.length,
		needMorItems: isLoadMoreItems.value && targetIndex.value >= matcherSKUsItems.value.length,

		setSelectedSKU,
		setTargetIndex,
		saveMapping,
		callNeedSku,
		handleMoreProducts
	}
}